interface AppWindow extends Window {
  dataLayer: { [key in string]: any }
}

declare const window: AppWindow

/**
 * Google Tag Manager のイベント送信
 *
 * @param name イベント名
 * @param defaultCustomValue デフォルトのカスタム値（既に BizHint の GTM アカウントに登録されている「custom_value」という名称の変数にバインド）
 * @param namedCustomValues 名前付きのカスタム値（上記デフォルトの名称以外の名前でパラメータを送りたい場合はこちらにオブジェクトで指定）。
 *                          GTM は push された値を上書きされるまで保持するため、前のイベントの値を消したいキーには undefined を渡す
 */
export function sendGtmEvent(name: string, defaultCustomValue?: string | number | boolean, namedCustomValues?: { [key in string]: string | number | boolean | undefined }) {
  if (!name) return

  window.dataLayer = window.dataLayer || []

  const e: { [key in string]: any } = {}

  e['event'] = name

  if (defaultCustomValue) {
    e['custom_value'] = defaultCustomValue
  }

  if (namedCustomValues) {
    Object.keys(namedCustomValues).forEach(key => {
      const _key = key as keyof typeof namedCustomValues
      e[_key] = namedCustomValues[_key]
    })
  }

  window.dataLayer.push(e)
}
